import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { Observable, of } from 'rxjs';
import { shareReplay, catchError } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CurrencyAccountService {
  private cache: { [key: string]: Observable<any> } = {};

  constructor(private api: ApiService) {}

  getCurrencyAccounts(
    nameEP: string = 'company-currency-accounts',
    isSupported: boolean | null = null,
    isWithdrawable: boolean | null = null,
  ): Observable<any> {
    const params = new HttpParams()
      .set('isSupported', isSupported !== null ? String(isSupported) : '')
      .set(
        'isWithdrawable',
        isWithdrawable !== null ? String(isWithdrawable) : '',
      );

    // Key for cache based on params
    const cacheKey = `${nameEP}|${isSupported}|${isWithdrawable}`;

    if (!this.cache[cacheKey]) {
      this.cache[cacheKey] = this.api.get(`v1/${nameEP}/`, params).pipe(
        shareReplay(1),
        catchError((err) => {
          // Invalidate cache on error
          delete this.cache[cacheKey];
          return of({ records: [] });
        }),
      );
    }
    return this.cache[cacheKey];
  }
  /**
   * Invalidate all cached currency account requests.
   */
  invalidateCache(): void {
    this.cache = {};
  }
}
